module.exports = __webpack_public_path__ + "img/preview-7.b06d7895.png";